module.exports = __webpack_public_path__ + "img/pg1.34ea7199.jpg";